const gridAutoRows = {
    name: "grid-auto-rows",
    path: "/grid-auto-rows",
    title: "grid-auto-rows",
    description: "Utilities for controlling the size of implicitly-created grid rows.",
    value: {
       "grid-auto-rows": {
          "auto-rows-auto": "auto",
          "auto-rows-min": "min-content",
          "auto-rows-max": "max-content",
          "auto-rows-fr": "minmax(0, 1fr)",
          "auto-rows-[<value>]": " <value>"
        },
    },
    exampleData: [
        {
            "title": "auto-rows-min, auto-rows-max",
            "description": "to control the size of implicitly-created grid rows:",
            "example": {
                "code": `
<div class="grid grid-flow-row auto-rows-max">
  <div>01</div>
  <div>02</div>
  <div>03</div>
</div>
                `
            },
        },
        {
            "title": "auto-rows-[<value>]",
            "description": "syntax to set the size of implicitly-created grid rows based on a completely custom value:",

            "example": {
                "code": `
<div class="auto-rows-[minmax(0,2fr)] ...">
  <!-- ... -->
</div>        `
            },
        }
    ],
};

export default gridAutoRows;